var __rspack_ns_object = JSON.parse('{"Load files":"加载文件","Load folders":"加载文件夹"}')